export default __webpack_public_path__ + "media/bundles/App/layout/icon/svgs/zoom-in-05850e2d7025ebc2cf9f305c621f93d0.svg";